import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
    getUserToken,
    setUserToken,
    setDeployment,
    setDefaultLanguage,
    setUserType,
    setUserId,
    setUserProfileData,
    routeAfterAuth,
    getTooltip,
    getOnboardingFlag,
    getConsentFlag,
    handleTooltipOnboarding,
    setParamToken,
    isNeGDDeployment,
} from "../../../Actions/Utils";
import { getUserData } from "../../../Actions/UserActions";
import { useNavigate } from "react-router-dom";

const Splash = ({ setSelectedLanguage, setStepIndex, setStartTour }) => {
    const [searchParams] = useSearchParams();
    const paramToken = searchParams.get("auth_token");
    const deployment = searchParams.get("deployment");
    const navigate = useNavigate();

    useEffect(() => {
        if (isNeGDDeployment()) {
            // NeGD login: use token directly via getUserData, then route via routeAfterAuth
            const token = getUserToken();
            if (token) {
                if (!getOnboardingFlag()) {
                    navigate("/guide");
                } else {
                    if (!getConsentFlag()) {
                        navigate("/consent");
                    } else {
                        const tooltip = getTooltip();
                        handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
                        navigate("/chat");
                    }
                }
                return;
            }
            if (paramToken) {
                let cancelled = false;
                const skipLogin = async () => {
                    setDeployment(deployment);
                    setUserToken(paramToken);
                    if (setSelectedLanguage) setSelectedLanguage("en");
                    setDefaultLanguage("en");
                    window.history.replaceState({}, document.title, window.location.pathname);

                    const data = await getUserData(paramToken);
                    if (cancelled) return;

                    if (data) {
                        setUserType(data.type);
                        setUserId(data.user_id);
                        setUserProfileData(data.profile);
                        await routeAfterAuth(data, navigate, setStepIndex, setStartTour);
                    } else {
                        localStorage.clear();
                        sessionStorage.clear();
                        navigate("/app-error");
                    }
                };
                skipLogin();
                return () => { cancelled = true; };
            }
            const timer = setTimeout(() => {
                navigate("/app-error");
            }, 2000);
            return () => clearTimeout(timer);
        } else {
            // Non-NeGD login: store param token and navigate to /lang
            const token = getUserToken();
            if (token) {
                navigate("/chat");
            } else {
                const timer = setTimeout(() => {
                    navigate("/lang");
                }, 2000);
                return () => clearTimeout(timer);
            }
        }
    }, [paramToken, deployment, navigate, setSelectedLanguage, setStepIndex, setStartTour]);

    return (
        <div
            style={{overflow: "scroll", backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")` }}
            className={`bg-[var(--primary-dark-2)] h-screen w-screen flex items-center justify-center bg-blend-color-burn`}
        >
            <div className="flex flex-col items-center justify-center text-[2rem]">
                {isNeGDDeployment() ? <img src={"/Assets/Images/Logo_Anganwadi.svg"} alt="aww" /> : <img src={"/Assets/Images/Logo.svg"} alt="asha" />}
            </div>
        </div>
    )
}

export default Splash;
